import type { ISpread } from "../../spreadsSlice";

export const threeCardsSpread: ISpread = {
  id: "spread_3_cards",
  name: "Три карты",
  altNames: ["Three-Card Spread"],
  purpose:
    "Универсальный расклад для краткого анализа ситуации или вопроса, понимания динамики событий, получения подсказки и самопознания.",
  cardsCount: 3,
  layout: "[1]   [2]   [3]",
  positions: [
    {
      id: "past",
      title: "Прошлое",
      meaning:
        "Прошлое или корень ситуации — то, что привело к текущему состоянию.",
    },
    {
      id: "present",
      title: "Настоящее",
      meaning:
        "Текущее состояние ситуации и то, что важно осознать сейчас.",
    },
    {
      id: "future",
      title: "Будущее",
      meaning:
        "Вероятное развитие и направление движения ситуации.",
    },
  ],
  symbolism:
    "Триада прошлого, настоящего и будущего отражает поток событий; также три карты выражают структуру начала, середины и завершения.",
  archetypes: ["Триада", "Поток времени", "Начало — середина — завершение"],
  psychology:
    "Помогает выявлять причинно-следственные связи, осознавать ресурсы и блоки и соединять разные аспекты ситуации в единый процесс.",
  procedure: {
    preparation:
      "Сформулировать чёткий вопрос или тему и заранее определить значения трёх позиций.",
    steps:
      "Перетасовать карты с концентрацией на вопросе; выложить три карты слева направо; прочитать их последовательно как прошлое, настоящее и будущее; затем сопоставить взаимосвязи между картами.",
  },
  interpretations: [
    "Карта прошлого показывает, что привело к текущему состоянию.",
    "Карта настоящего показывает, что важно осознать прямо сейчас.",
    "Карта будущего указывает вероятное направление дальнейшего развития.",
  ],
  nuances: [
    "Значения позиций нужно определить до выкладки и не менять после получения карт.",
    "Если значение отдельной карты неочевидно, её следует рассматривать во взаимосвязи с другими картами.",
    "Трёхкартный расклад показывает динамику ситуации, а не фиксированный окончательный прогноз.",
    "SOURCE допускает и другие варианты трёх позиций: «Ситуация — Вызов — Совет», «Тело — Разум — Дух», «Вы — Отношение к ситуации — Результат». В текущей реализации используется вариант «Прошлое — Настоящее — Будущее».",
  ],
  examples: [
    {
      cards: ["5 Мечей", "Король Кубков", "Шут"],
      interpretation:
        "Конфликт → эмоциональное принятие → новое начало.",
    },
  ],
  selfQuestions: [
    "Что мне нужно отпустить из прошлого?",
    "Какие внутренние ресурсы сейчас доступны?",
    "В каком направлении мне двигаться?",
  ],
};

